import { isSafari } from 'react-device-detect'
import styled from 'styled-components'

import 'react-responsive-modal/styles.css'
import { applyIPadOnlyStyle, getResponsiveFontSizeCSS } from 'helpers/css'
import { isMobileOrIPad } from 'utils/device'

export const Container = styled.div`
    background: #000000;
    opacity: 0.6;
    width: 100vw;
    height: 100vh;
    position: absolute;
    top: 0;
    z-index: 1000;
`

export const Content = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 45px;

    ${applyIPadOnlyStyle(
        `
        justify-content: space-around;
    `,
        {
            min: 0,
            max: 1370,
            orientation: 'both',
        }
    )}
`

export const Header = styled.div``

export const Title = styled.div`
    font-style: normal;
    font-weight: 600;
    font-size: ${getResponsiveFontSizeCSS(20, 24)};
    line-height: 27px;
    text-align: center;

    color: #e87d7c; /* dull orange */
`

export const SubTitle = styled.div`
    font-weight: 600;
    font-size: ${getResponsiveFontSizeCSS(14, 18)};
    line-height: 24px;
    text-align: center;
    letter-spacing: -0.01em;
    color: #c4c4c4;
`

export const VideoWrapper = styled.div`
    width: 26vw;
    height: 19vw;

    @media only screen and (max-width: 992px) {
        display: none;
    }
`

export const Video = styled.img`
    width: 100%;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.1));
    border-radius: 5px;
`

export const Footer = styled.div``

export const Arrow = styled.img`
    position: absolute;
    left: 15%;
    top: 18%;
    ${(isMobileOrIPad || isSafari) && `display: none;`}
`
